import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudProject = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'project/',
    params: params,
    method: 'get'
  })
}

export const detailPrivateCloudProject = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'project/',
    method: 'get'
  })
}

export const editPrivateCloudProject = (data, id) => {
  let url = `${privateCloudBaseUrl}project/`
  let method = 'post'
  if (id) {
    url += `${id}/`
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deletePrivateCloudProject = (id) => {
  return axios.request({
    url: `${privateCloudBaseUrl}project/${id}/`,
    method: 'delete'
  })
}

export const updateMemberPrivateCloudProject = (data, id) => {
  return axios.request({
    url: `${privateCloudBaseUrl}project/${id}/member/`,
    data: data,
    method: 'put'
  })
}

export const getPrivateCloudProjectIsAdminRole = (id) => {
  return axios.request({
    url: `${privateCloudBaseUrl}project/${id}/is_admin_role/`,
    method: 'get'
  })
}
